import useSWR from 'swr';
import getMarcapassoById from '../services/marcapasso';

export default function useMarcapasso(id) {
  return useSWR(id ? ['marcapasso', id] : null, () => getMarcapassoById(id));
}
